import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import AddSvg from 'assets/svgr-icons/Add.svg'
import UploadSvg from 'assets/svgr-icons/Upload.svg'

export const AddVoiceCard = styled.button<{ $isDragActive: boolean }>`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  border: 1px dashed ${COLORS.secondarySemiLight};
  border-radius: 4px;
  background-color: ${COLORS.primaryExtraLight};
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    border-color: ${COLORS.primaryDark};
    background-color: ${COLORS.primaryLight};
  }

  ${({ $isDragActive }) =>
    $isDragActive &&
    css`
      border-color: ${COLORS.primaryDark};
      background-color: ${COLORS.primaryLight};

      /* Children must not steal dragleave/drop from the card itself. */
      & > * {
        pointer-events: none;
      }
    `}
`

export const AddIcon = styled(AddSvg)`
  width: 20px;
  height: 20px;
  color: ${COLORS.secondaryDark};
`

export const UploadIcon = styled(UploadSvg)`
  width: 20px;
  height: 20px;
  fill: ${COLORS.secondaryDark};
`
